export const formatOrgnr = (orgnr: string) => {
    //  xxxxxxxxx -> xxx xxx xxx
    return orgnr.length === 9 ? orgnr.replace(/(?=.{3}$)/, ' ').replace(/(?=.{7}$)/, ' ') : orgnr
}
export const formatFnrOrgnr = (string: string) => {
    // xxxxxxxxxxx -> xxxxxx xxxxx
    return string.length > 9 ? string.replace(/(?=.{5}$)/, ' ') : string.replace(/(?=.{3}$)/, ' ').replace(/(?=.{7}$)/, ' ')
}
